import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  Dropdown,
  Form,
  InputGroup,
  Row,
  Stack,
} from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import DateRangePicker from "../../../common/CustomDateRangePicker";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { downloadZipFileForDictations } from "../../../services/EditorWorkFlowAPI";
import AppointmentActionsDropdown from "../../../common/AppointmentActionsDropdown";
import Snackbar from "../../../common/Snackbar";
import {
  CASE_STAGE_STATUS,
  EDITOR_REPORT_STATUS,
  TRANSCRIBER_SUMMARY_CODES,
  TRANSCRIPTION_REPORT_STATUS,
} from "../../../common/Constant";
import CustomPagination from "../../../common/Pagination";
import TableRowsPerPage from "../../../common/TableRowsPerPage";
import Loader from "../../../common/Loader";
import UploadStatusFloatingIcon from "../../../common/UploadStatusFloatingIcon";
import useAnimatedCounter from "../useAnimatedCounter";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../redux/slice/CaseHeaderSlice";
import EditorUploadRecordTabIndex from "../Editor/components/EditorUploadRecord/EditorUploadRecordTabIndex";
import EditorCommonDrawer from "../Editor/components/EditorCommonDrawer";
import TranscriberAddNotes from "../Transcriber/components/TranscriberAddNotes";
import AssignToTranscriber from "../Transcriber/components/AssignToTranscriber";
import {
  TRANSCRIPITON_TODO_HEADERS,
  EXPORTTRANSCRIPITON_TODO_HEADERS,
} from "./actions/constant";
import TransriberDataTable from "./components/TranscriberDatatable";
import {
  getTranscriberSimpleSearch,
  getTranscriberSummary,
} from "../../../services/TranscriberAPI";
import TranscriberUploadRecordTabIndex from "./components/TranscriberUploadRecord/TranscriberUploadRecordTabIndex";
import { getDownloadFileForPopUpDetails } from "../../../services/UploadRecordsApi";
import {  transcriberReportStatusUpdate } from "../../../services/TranscriberAPI";

interface TranscriberDashboardProps {
  setShowMainHeader: React.Dispatch<React.SetStateAction<boolean>>;
}

const TranscriberDashboard: React.FC<TranscriberDashboardProps> = ({
  setShowMainHeader,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [editorData, setEditorData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [activeFilter, setActiveFilter] = useState(
    TRANSCRIBER_SUMMARY_CODES.OVERDUE_TODAY,
  );
  const [activeCard, setActiveCard] = useState<string>("Overdue");
  const [activeSubCard, setActiveSubCard] = useState<string>("Today");
  const [activeListName, setActiveListName] = useState<string>(
    "Overdue List (Today)",
  );
  const [allReports, setAllReports] = useState<string>("");
  const [neardueCount, setNeardueCount] = useState<string>("");
  const [todayOverdueCount, setTodayOverdueCount] = useState<string>("");
  const [overdueCount, setOverdueCount] = useState<string>("");
  const [transcriptionNotInitiated, setTranscriptionNotInitiated] =
    useState<string>("");

  const [transcriptionInProgress, setTranscriptionInProgress] =
    useState<string>("");
  const [transcriptionCompleted, setTranscriptionCompleted] =
    useState<string>("");

  const [exceptionCount, setExceptionCount] = useState<string>("");

  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [qmeScheduleId, setqmeScheduleId] = useState<Number>();
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any[]>([]);
  const [showModalNew, setShowModalNew] = useState(false);

  const [totalRows, setTotalRows] = useState<any>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(15);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<string>("DESC");

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0);
  console.log(lastDayOfMonth, "lastDayOfMonth");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [showMessagePopUp, setShowMessagePopUp] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([firstDayOfMonth, lastDayOfMonth]);

  const [computedMinDate, setComputedMinDate] = useState<Date | undefined>();
  const [computedMaxDate, setComputedMaxDate] = useState<Date | undefined>();
  const [downloadStatuses, setDownloadStatuses] = useState<any>({});

  const handleDateRangeChange = (newRange: [Date | null, Date | null]) => {
    const [start, end] = newRange;
    setDateRange([start ?? undefined, end ?? undefined]);
  };

  useEffect(() => {
    const min = new Date(today);
    min.setFullYear(today.getFullYear() - 1);

    const max = new Date(today);
    max.setFullYear(today.getFullYear() + 1);

    setComputedMinDate(min);
    setComputedMaxDate(max);
  }, []);

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [dwcStatus, setdwcStatus] = useState<string>("");

  const inputRef = useRef<HTMLInputElement | null>(null);

  const toLocalISOString = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getSearchTranscriberData = async (
    query: string = "",
    action: string = "",
    pageNumber: number = 1,
    pageSize: number = itemsPerPage,
    key: string = sortColumn,
    direction: string = sortOrder,
  ) => {
    try {
      setLoading(true);
      // Convert dateRange to ISO strings safely
      const trimmedQuery = query?.trim();
      const [start, end] = dateRange;
      const payload = {
        searchString: trimmedQuery || "",
        startDate: start ? toLocalISOString(start) : "",
        endDate: end ? toLocalISOString(end) : "",

        actionTrigger: action,
        pageNumber,
        pageSize,
        sortColumn: key,
        sortOrder: direction,
      };

      const response = await getTranscriberSimpleSearch(payload);

      // Step 3: Set state with updated response
      setEditorData(response);
      setTotalPages(response[0]?.totalPages || 1);
      setTotalRows(response[0]?.totalCount || null);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const latestSummaryRequestId = useRef(0);

  const getTranscriberSummaryData = async (
    query: string = "",
    action: string = "",
  ) => {
    const requestId = ++latestSummaryRequestId.current;
    try {
      // Convert dateRange to ISO strings safely
      const trimmedQuery = query?.trim();
      const [start, end] = dateRange;
      const payload = {
        searchString: query || "",
        startDate: start ? toLocalISOString(start) : "",
        endDate: end ? toLocalISOString(end) : "",

        // actionTrigger: action,
      };

      const response = await getTranscriberSummary(payload);
      if (requestId !== latestSummaryRequestId.current) return;

      if (response) {
        setAllReports(response?.allTranscription ?? "");
        setTodayOverdueCount(response?.todayDueCount ?? "");
        setOverdueCount(response?.totalOverdueCount ?? "");
        setNeardueCount(response?.nearDueCount ?? "");

        setTranscriptionInProgress(
          response?.totalTranscriptionInProgressCount ?? "",
        );
        setTranscriptionCompleted(response?.totalCompletedCount ?? "");
        setExceptionCount(response?.totalExceptionCount ?? "");

        setTranscriptionNotInitiated(
          response?.totalTranscriptionPendingCount ?? "",
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const [start, end] = dateRange;

    if (start && end) {
      getSearchTranscriberData(
        searchQuery,
        activeFilter,
        currentPage,
        itemsPerPage,
        sortColumn,
        sortOrder,
      );
    }
  }, [
    dateRange,
    searchQuery,
    currentPage,
    itemsPerPage,
    sortColumn,
    sortOrder,
  ]);

  useEffect(() => {
    const [start, end] = dateRange;

    if (start && end) {
      getTranscriberSummaryData(searchQuery, activeFilter);
    }
  }, [dateRange, searchQuery]);

  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleInputChange = debounce((value: string) => {
    if (value.length >= 3 || value.length === 0) {
      setSearchQuery(value);
      setCurrentPage(1);
    }
  }, 300);

  const handleResetFilters = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
    }

    setSearchQuery("");
    // setTotalPages(1);
    // setCurrentPage(1);
    // setSortOrder("DESC");
    // setDateRange([firstDayOfMonth, lastDayOfMonth]);

    // const filter = EDITOR_SUMMARY_CODES.OVERDUE_NEARDUE;

    // setActiveCard("Overdue");
    // setActiveSubCard("Today");
    // setActiveFilter(filter);
  };

  useEffect(() => {
    if (!activeFilter) return;

    const filterQuery = searchQuery || "";
    // First get summary
    getTranscriberSummaryData(filterQuery, activeFilter);

    // Then get search table
    getSearchTranscriberData(
      filterQuery,
      activeFilter,
      1,
      itemsPerPage,
      sortColumn,
      "DESC",
    );
  }, [activeFilter, dateRange]);

  const assignTranscriber = () => {
    setSnackbarMessage("Assigned to transcriber successfully.");
    setError("success");
    setSnackbarOpen(true);
    handleSaveTranscriberChanges();
  };

  const handleSaveTranscriberChanges = () => {
    setSelectedIds([]);
    setSelectedRowData([]);
    setSelectAll(false);
    setShowMainHeader(true);
    setShowAppointmentActionDrawer(false);
    getSearchTranscriberData(
      searchQuery,
      activeFilter,
      currentPage,
      itemsPerPage,
      sortColumn,
      sortOrder,
    );
    getTranscriberSummaryData(searchQuery, activeFilter);
  };

  const NON_SELECTABLE_STAGES = [
    CASE_STAGE_STATUS.CLOSED,
    CASE_STAGE_STATUS.CANCELLED,
  ];

  const handleCheckboxSelect = (selectedRows: any[]) => {
    const invalidRows = selectedRows.filter((row) =>
      NON_SELECTABLE_STAGES.includes(row?.caseStage),
    );

    if (invalidRows.length > 0) {
      const hasClosed = invalidRows.some(
        (row) => row.caseStage === CASE_STAGE_STATUS.CLOSED,
      );

      const hasCancelled = invalidRows.some(
        (row) => row.caseStage === CASE_STAGE_STATUS.CANCELLED,
      );

      let message = "Invalid case selection.";

      if (hasClosed && hasCancelled) {
        message = "Some cases are closed and some are cancelled.";
      } else if (hasClosed) {
        message = "Case has been closed.";
      } else if (hasCancelled) {
        message = "Case has been cancelled.";
      }

      setSnackbarMessage(message);
      setError("error");
      setSnackbarOpen(true);
    }


    const validRows = selectedRows.filter(
      (row) => !NON_SELECTABLE_STAGES.includes(row?.caseStage),
    );

    const ids = validRows
      ?.map((r: any) => String(r?.subjectQmeScheduleId))
      ?.filter(Boolean);

    setSelectedIds(ids);
    setqmeScheduleId(Number(ids));
    setSelectedRowData(validRows);
    setdwcStatus(String(dwcStatus));
  };

  const [selectedAction, setSelectedAction] = useState<string | number>("");

  const [showAppointmentActionDrawer, setShowAppointmentActionDrawer] =
    useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");

  const allOptions = [
    // {
    //   value: "Assign Transcriber",
    //   label: "Assign To Transcriber",
    // },

    {
      value: "Upload Records",
      label: "Upload / Review Transcripts",
    },
    {
      value: "Add Notes",
      label: "Add Notes / Exception",
    },
     {
      value: "Download Dictation",
      label: "Download Dictation",
    },
  ];

  const multiSelectRestrictedValues = ["Upload Records", "Add Notes"];

  const selectedRow = selectedRowData?.[0];

  const ASSIGN_EDITOR_BLOCKED_STATUSES = [
    EDITOR_REPORT_STATUS.SENT_FOR_REWORK,
    EDITOR_REPORT_STATUS.APPROVED_BY_DOCTOR,
    EDITOR_REPORT_STATUS.PENDING_DOCTOR_APPROVAL,
    EDITOR_REPORT_STATUS.COMPLETED,
    TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_COMPLETED,
  ];

  const hasBlockedAssignEditorStatus = selectedRowData?.some((row) =>
    ASSIGN_EDITOR_BLOCKED_STATUSES.includes(row?.transcriptionStatus),
  );

  const isCompletedReport =
    selectedRow?.transcriptionStatus ===
    TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_COMPLETED;

  const isMultiSelect = selectedIds?.length > 1;
  const isPastOverdueList =
    activeListName === "Overdue List (Past Overdue)" ||
    activeListName === "Editing Not Initiated List (Overdue)";

  const filteredOptions = allOptions.filter((opt) => {
    if (isMultiSelect && multiSelectRestrictedValues.includes(opt.value)) {
      return false;
    }

    if (opt.value === "Assign Transcriber" && hasBlockedAssignEditorStatus) {
      return false;
    }

    return true;
  });

  const finalOptions = filteredOptions.map((opt) => {
    if (opt.value === "Upload Records" && isCompletedReport) {
      return {
        ...opt,
        label: "Review Transcripts",
      };
    }

    return opt;
  });

  const handleActionChange = (value: string | number) => {
    setSelectedAction(value);
    if (value === "Assign Transcriber") {
      setDrawerTitle("Assign Transcriber");
      setShowAppointmentActionDrawer(true);
    }
    if (value === "Add Notes") {
      setDrawerTitle("Add Notes");
      setShowAppointmentActionDrawer(true);
    }

    if (value === "DWC Extension") {
      setDrawerTitle("DWC Extension");
      setShowAppointmentActionDrawer(true);
    }

    if (value === "Upload Records") {
      setShowMainHeader(false);
    }
  };

  const refreshAppointmentData = () => {
    handleResetFilters();
    setSelectedIds([]);
    setSelectedRowData([]);
    setSelectAll(false);
    setShowMainHeader(true);
  };

  const handlecloseActionDrawer = async () => {
    handleSaveTranscriberChanges();
    handleCloseModalNew();
  };

  const handleActionDrawer = () => {
    setShowAppointmentActionDrawer(false);
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
    setSelectedAction("");
    // refreshAppointmentData();
  };

  const getBase64FromUrl = async (url: string): Promise<string> => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === "string") {
          resolve(reader.result);
        } else {
          reject("Failed to convert blob to base64");
        }
      };
      reader.onerror = () => reject("Failed to read blob");
      reader.readAsDataURL(blob);
    });
  };
  const handleExportPDF = async () => {
    try {
      const selectedStatus = activeListName;
      const [startDate, endDate] = dateRange;

      // ---------- Date Label ----------
      const formatDate = (date: Date) =>
        date.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        });

      let dateLabel = "";
      if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
        dateLabel = `${formatDate(startDate)} to ${formatDate(endDate)}`;
      } else {
        dateLabel = formatDate(startDate || new Date());
      }

      const title = `Appointments for ${selectedStatus} ${dateLabel}`;

      const logoBase64 = await getBase64FromUrl("/logo.png");

      // ---------- Headers ----------
      const headers: string[] = [
        "Sr. No",
        ...EXPORTTRANSCRIPITON_TODO_HEADERS.map((h: any) => h.label || h.name),
      ];

      // ---------- API ----------
      const trimmedQuery = searchQuery?.trim();
      const payload = {
        searchString: trimmedQuery,
        startDate: startDate ? toLocalISOString(startDate) : "",
        endDate: endDate ? toLocalISOString(endDate) : "",
        actionTrigger: activeFilter,
        pageNo: 1,
        pageSize: 100000,
        sortColumn: "",
        sortOrder: "DESC",
      };

      const response = await getTranscriberSimpleSearch(payload);

      if (!Array.isArray(response) || response.length === 0) {
        alert("No data available for export");
        return;
      }

      // ---------- Table Data (IMPORTANT FIX) ----------
      const tableData: (string | number | null)[][] = response.map(
        (row: any, index: number) => {
          const obj: (string | number | null)[] = [];
          obj.push(index + 1);

          EXPORTTRANSCRIPITON_TODO_HEADERS.forEach((header: any) => {
            let val = row[header.key] ?? "";

            if (header.key === "caseid" && typeof val === "string") {
              val = val.slice(-3);
            }

            obj.push(val);
          });

          return obj;
        },
      );

      // ---------- PDF ----------
      const doc = new jsPDF("landscape", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 10;

      autoTable(doc, {
        head: [headers],
        body: tableData,
        margin: { top: 28, left: 2 },
        styles: { fontSize: 9, cellPadding: 2, overflow: "linebreak" },
        tableWidth: pageWidth - margin,
        columnStyles: {
          2: { cellWidth: 30 },
          3: { cellWidth: 30 },
          5: { cellWidth: 25 },
        },

        didDrawPage: (data) => {
          // ===== HEADER =====
          // ===== HEADER =====
          doc.setFontSize(12);
          doc.text("Medical Legal Portal", 2, 14);
          doc.addImage(logoBase64, "PNG", pageWidth - margin - 28, 5, 34, 12);

          // ===== TITLE (below header, same left alignment) =====
          doc.setFontSize(12);
          doc.text(title, 2, 22); // same X (2), lower Y

          // ===== FOOTER =====
          const footerY = pageHeight - 10;
          const now = new Date();
          const formattedDate = now.toLocaleString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });

          const firstName = localStorage.getItem("firstname") ?? "";
          const lastName = localStorage.getItem("lastname") ?? "";

          const generatedByText = `Generated By & On - ${firstName} ${lastName} ${formattedDate}`;
          const pageNumberText = `Page No. ${
            data.pageNumber
          } of ${doc.getNumberOfPages()}`;

          doc.setDrawColor(0);
          doc.setLineWidth(0.1);
          doc.line(1, footerY - 5, pageWidth - 1, footerY - 5);

          doc.setFontSize(8);
          doc.text(generatedByText, 1, footerY);
          doc.text(
            pageNumberText,
            pageWidth - doc.getTextWidth(pageNumberText) - 1,
            footerY,
          );
        },
      });

      const safeFileName = title.replace(/[\/\\:*?"<>|]/g, "-");
      doc.save(`${safeFileName}.pdf`);
    } catch (error) {
      console.error("PDF Export Error:", error);
    }
  };

  const handleExportExcel = async () => {
    const sheetName = "TranscriberData";
    const selectedStatus = activeListName;
    const [startDate, endDate] = dateRange;

    const formatDate = (date: Date) =>
      date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });

    let dateLabel = "";
    if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
      dateLabel = `${formatDate(startDate)} to ${formatDate(endDate)}`;
    } else {
      dateLabel = formatDate(startDate || new Date());
    }

    const title = `Appointments for ${selectedStatus} ${dateLabel}`;

    const headers = [
      "Sr. No",
      ...EXPORTTRANSCRIPITON_TODO_HEADERS.map((h: any) => h.label || h.name),
    ];
    const trimmedQuery = searchQuery?.trim();
    const payload = {
      searchString: trimmedQuery,
      startDate: startDate ? toLocalISOString(startDate) : "",
      endDate: endDate ? toLocalISOString(endDate) : "",
      actionTrigger: activeFilter,
      pageNo: 1,
      pageSize: 100000,
      sortColumn: "",
      sortOrder: "DESC",
    };

    const response = await getTranscriberSimpleSearch(payload);
    type ExcelRow = (string | number | null | undefined)[];

    const exportData: ExcelRow[] = response.map((row: any, index: number) => {
      const rowArr: ExcelRow = [];
      rowArr.push(index + 1);

      EXPORTTRANSCRIPITON_TODO_HEADERS.forEach((header: any) => {
        let val = row[header.key];
        if (header.key === "caseid" && typeof val === "string") {
          val = val.slice(-3);
        }
        rowArr.push(val);
      });

      return rowArr;
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    // Title row
    worksheet.mergeCells(1, 1, 1, headers.length);
    const titleCell = worksheet.getCell(1, 1);
    titleCell.value = title;
    titleCell.font = { bold: true, size: 14 };

    // Header row
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };

    // Data rows
    exportData.forEach((row) => worksheet.addRow(row));

    // Column widths
    worksheet.columns.forEach((col, index) => {
      col!.width = index === 0 ? 10 : 25;
    });

    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      `${title.replaceAll("/", "-")}.xlsx`,
    );
  };

  const handleDownloadProgress = async (
    id: string,
    downloadFn: () => Promise<any>,
    fileName: string = "File.zip",
  ) => {
    setDownloadStatuses((prev: any) => ({
      ...prev,
      [id]: { fileName, progress: 0, isUploading: true },
    }));

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 90) return;
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress },
      }));
    }, 300);

    try {
      await downloadFn();
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress: 100, isUploading: false },
      }));
      setTimeout(() => {
        setDownloadStatuses((prev: any) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
      }, 2000);
    } catch (error) {
      console.error("Download error:", error);
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], isUploading: false },
      }));
    }
  };

  const handleDownloadSingleFileTranscriber = (row: any) => {
    handleDownloadProgress(
      row?.caseRecordDetailsId,
      () =>
        getDownloadFileForPopUpDetails(
          row?.caseRecordDetailsId,
          row?.transcriptionFile,
        ),
      row?.transcriptionFile,
    );
  };

  const handleDownload = async() => {
    const subjectQmeScheduleIDs = selectedRowData
      ?.map((item) => item.subjectQmeScheduleID)
      .filter((id) => id != null)
      .join(",");
    setSnackbarMessage("Downloading Dictations");
    setError("success");
    setSnackbarOpen(true);
    // downloadZipFileForDictations(subjectQmeScheduleIDs);
    await handleDownloadProgress(`doc-${Date.now()}`, () =>
      downloadZipFileForDictations(subjectQmeScheduleIDs),
    );

    const payloadReport = {
          subjectQmeScheduleID: subjectQmeScheduleIDs,
          reportStatus:"TranscriptionInProgress",
        };
    
        await transcriberReportStatusUpdate(payloadReport);
    setShowModalNew(false);
    setSelectedAction("");
    handleSaveTranscriberChanges();
  };

 

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    getSearchTranscriberData(
      searchQuery,
      activeFilter,
      pageNumber,
      itemsPerPage,
      sortColumn,
      sortOrder,
    );
  };

  const handleSortAction = (row: any) => {
    setSortColumn(row.key);
    setSortOrder(row.direction);
    getSearchTranscriberData(
      searchQuery,
      activeFilter,
      currentPage,
      itemsPerPage,
      row.key,
      row.direction,
    );
  };

  const handleRowsPerPageChange = (value: number) => {
    setItemsPerPage(value);
    setCurrentPage(1);
  };

  // Calculate text for the range of entries currently visible
  const entriesText = !totalRows
    ? "Showing 0 of 0 entries"
    : `Showing ${(currentPage - 1) * itemsPerPage + 1} to ${Math.min(
        currentPage * itemsPerPage,
        totalRows,
      )} of ${totalRows} entries`;

  const handleCardClick = (filter: string) => {
    const current = 1;
    const perPage = 15;
    const column = "";
    const order = "DESC";

    setActiveFilter(filter);
    setCurrentPage(current);
    setItemsPerPage(perPage);
    setSortColumn(column);
    setSortOrder(order);
    setSelectedIds([]);
    setSelectedRowData([]);
    setSelectAll(false);
  };

  const getCurrentMonthRange = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 2, 0);
    return [firstDay, lastDay] as [Date, Date];
  };

  const handleResetDate = () => {
    const [start, end] = getCurrentMonthRange();
    setDateRange([start, end]);
  };

  const animatedAllReports = useAnimatedCounter(allReports);
  const animatedNearDue = useAnimatedCounter(neardueCount);
  const animatedTodayOverdue = useAnimatedCounter(todayOverdueCount);
  const animatedOverdue = useAnimatedCounter(overdueCount);

  const animatedTranscriptionNotInitiated = useAnimatedCounter(
    transcriptionNotInitiated,
  );

  const animatedTranscriptionInProgress = useAnimatedCounter(
    transcriptionInProgress,
  );
  const animatedTranscriptionCompleted = useAnimatedCounter(
    transcriptionCompleted,
  );

  const animatedExceptionCount = useAnimatedCounter(exceptionCount);

  const dispatch = useDispatch();

  const [visibleHeaderIndex, setVisibleHeaderIndex] = useState<boolean>(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleCaseClick = (row: any) => {
    dispatch(setIsDashboard(true));
    dispatch(setNewCaseInFoID(row.caseInfoId));
    setVisibleHeaderIndex(true);
    sessionStorage.setItem("fromMyTodos", "true");
    navigate("/search-case", {
      state: {
        from: "mytodos",
        myTodosState: {
          searchQuery,
          dateRange,
          activeFilter,
          activeCard,
          activeSubCard,
          activeListName,
          currentPage,
          itemsPerPage,
          sortColumn,
          sortOrder,
        },
      },
    });
  };

  const resetToDefault = () => {
    setSearchQuery("");
    setDateRange([firstDayOfMonth, lastDayOfMonth]);
    setActiveFilter(TRANSCRIBER_SUMMARY_CODES.OVERDUE_NEARDUE);
    setActiveCard("Overdue");
    setActiveSubCard("Today");
    setActiveListName("Overdue List (Today)");
    setCurrentPage(1);
    setItemsPerPage(15);
    setSortColumn("");
    setSortOrder("DESC");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const cameFromMyTodos = sessionStorage.getItem("fromMyTodos");

    if (cameFromMyTodos === "true" && location.state?.from === "mytodos") {
      const s = location.state.myTodosState;

      setSearchQuery(s.searchQuery);
      setDateRange(s.dateRange);
      setActiveFilter(s.activeFilter);
      setActiveCard(s.activeCard);
      setActiveSubCard(s.activeSubCard);
      setActiveListName(s.activeListName);
      setCurrentPage(s.currentPage);
      setItemsPerPage(s.itemsPerPage);
      setSortColumn(s.sortColumn);
      setSortOrder(s.sortOrder);

      if (inputRef.current) {
        inputRef.current.value = s.searchQuery || "";
        getTranscriberSummaryData(s.searchQuery, activeFilter);
      }

      sessionStorage.removeItem("fromMyTodos");
    } else {
      resetToDefault();
    }
  }, []);
 useEffect(() => {
    if (selectedAction === "Download Dictation") {
      handleDownload();
    }
  }, [selectedAction]);
  return (
    <>
      <UploadStatusFloatingIcon
        uploadStatuses={downloadStatuses}
        isUpload={false}
        onCancelUpload={(id: any) => {
          setDownloadStatuses((prev: any) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
          });
        }}
      />
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      {selectedAction === "Upload Records" ? (
        <TranscriberUploadRecordTabIndex
          editorData={selectedRowData}
          SelectedRowsDataTo={selectedIds}
          close={handlecloseActionDrawer}
        />
      ) : (
        <div className="main_wrapper_section appoinment_wrapper mt-3 fade-in-left">
          <Loader isLoading={loading} />

          <Container fluid className="px-5">
            <Row className="g-3">
              {" "}
              {/* g-3 adds equal gaps between cards */}
              {/* Card 1 */}
              <Col md={2}>
                <Card
                  className={`h-100 todocard1 ${
                    activeCard == "Overdue" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#ffeae9",
                    borderRadius: "5px",
                    border: "1px solid #FEA1A1",
                  }}
                  onClick={() => {
                    setActiveCard("Overdue");
                    setActiveListName("Overdue List (Today)");
                    handleCardClick(TRANSCRIBER_SUMMARY_CODES.OVERDUE_TODAY);
                    setActiveSubCard("Today");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    {/* Header Row */}
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#FF6D6D",
                          fontSize: "14px",
                          fontWeight: "600",
                          marginBottom: "0px",
                        }}
                      >
                        Overdue Reports
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#fe6767" }}
                      >
                        timer
                      </span>
                    </div>

                    {/* Two-line details */}
                    <div className="d-flex justify-content-start">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(
                            TRANSCRIBER_SUMMARY_CODES.OVERDUE_NEARDUE,
                          );
                          setActiveSubCard("Near");
                          setActiveListName("Overdue List (Near Due)");
                          setActiveCard("Overdue");
                        }}
                        style={{
                          cursor: "pointer",
                          borderRight: "1px solid transparent",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #E5B7B7 10%, #E5B7B7 90%, transparent 90%) right / 1px 100% no-repeat",
                        }}
                        className={`borderRight px-1 sub-section-1 ${
                          activeSubCard == "Near" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#000" }}>
                          Near Due
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#fe6767",
                            fontWeight: "600",
                          }}
                        >
                          {animatedNearDue}
                        </div>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(
                            TRANSCRIBER_SUMMARY_CODES.OVERDUE_TODAY,
                          );
                          setActiveSubCard("Today");
                          setActiveListName("Overdue List (Today)");
                          setActiveCard("Overdue");
                        }}
                        style={{
                          cursor: "pointer",
                          borderRight: "1px solid transparent",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #E5B7B7 10%, #E5B7B7 90%, transparent 90%) right / 1px 100% no-repeat",
                        }}
                        className={`borderRight px-2 sub-section-1 ${
                          activeSubCard == "Today" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#000" }}>
                          Today
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#fe6767",
                            fontWeight: "600",
                          }}
                        >
                          {animatedTodayOverdue}
                        </div>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(TRANSCRIBER_SUMMARY_CODES.OVERDUE);
                          setActiveSubCard("OVDU");
                          setActiveListName("Overdue List (Past Overdue)");
                          setActiveCard("Overdue");
                        }}
                        style={{
                          cursor: "pointer",
                        }}
                        className={`px-1 sub-section-1 ${
                          activeSubCard == "OVDU" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#000" }}>
                          Overdue
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#fe6767",
                            fontWeight: "600",
                          }}
                        >
                          {animatedOverdue}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              {/* Card 2 */}
              <Col md={2}>
                <Card
                  className={`h-100 ${activeCard == "NI" ? "active" : ""}`}
                  style={{
                    backgroundColor: "#E8E8E8",
                    borderRadius: "5px",
                    border: "1px solid #99999C",
                  }}
                  onClick={() => {
                    setActiveCard("NI");
                    setActiveListName("Pending List");
                    setActiveSubCard("");
                    handleCardClick(
                      TRANSCRIBER_SUMMARY_CODES.EDITING_NOT_INITIATED,
                    );
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#99999C",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                       Pending
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#99999C" }}
                      >
                        question_mark
                      </span>
                    </div>
                    <div
                      style={{
                        color: "#99999C",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                      }}
                    >
                      {animatedTranscriptionNotInitiated}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2}>
                <Card
                  className={`h-100 todocard3 ${
                    activeCard == "Transcription" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#D6F2FF",
                    borderRadius: "5px",
                    border: "1px solid #99CEE8",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setActiveCard("Transcription");
                    setActiveSubCard("TRIP");
                    setActiveListName("Transcription List (In Progress)");
                    handleCardClick(
                      TRANSCRIBER_SUMMARY_CODES.EDITING_NOT_INITIATED,
                    );
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#0086ce",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Transcription
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#0086ce" }}
                      >
                        draft
                      </span>
                    </div>
                    <div className="d-flex justify-content-start">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveCard("Transcription");

                          setActiveListName("Transcription List (In Progress)");
                          handleCardClick(
                            TRANSCRIBER_SUMMARY_CODES.TRANSCRIPTION_IN_PROGRESS,
                          );
                          setActiveSubCard("TRIP");
                        }}
                        style={{
                          cursor: "pointer",
                          borderRight: "1px solid transparent",
                          padding: "0px 60px 0px 0px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #0086ce 10%, #0086ce 90%, transparent 90%) right / 1px 100% no-repeat",
                        }}
                        className={`borderRight px-1 sub-section-1 ${
                          activeSubCard == "TRIP" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#0086ce" }}>
                          In Progress
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#0086ce",
                            fontWeight: "600",
                          }}
                        >
                          {animatedTranscriptionInProgress}
                        </div>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveCard("Transcription");
                          setActiveSubCard("");
                          setActiveListName("Transcription List (Completed)");
                          handleCardClick(
                            TRANSCRIBER_SUMMARY_CODES.TRANSCRIPTION_COMPLETED,
                          );
                          setActiveSubCard("TRCD");
                        }}
                        style={{
                          cursor: "pointer",
                          padding: "0px 10px 0px 10px",
                        }}
                        className={` px-1 sub-section-1 ${
                          activeSubCard == "TRCD" ? "active" : ""
                        }`}
                      >
                        <div style={{ fontSize: "11px", color: "#0086ce" }}>
                          Completed
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#0086ce",
                            fontWeight: "600",
                          }}
                        >
                          {animatedTranscriptionCompleted}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              {/* Add more cards similarly */}
              <Col md={2}>
                <Card
                  className={`h-100 todocard9 ${
                    activeCard == "Exception" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#f8dcb4",
                    borderRadius: "5px",
                    border: "1px solid #EFCA93",
                  }}
                  onClick={() => {
                    setActiveCard("Exception");
                    setActiveListName("Exception List");
                    setActiveSubCard("");
                    handleCardClick(
                      TRANSCRIBER_SUMMARY_CODES.TRANSCRIPTION_EXCEPTION,
                    );
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#995911",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Exception
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#995911" }}
                      >
                        question_mark
                      </span>
                    </div>
                    <div
                      style={{
                        color: "#995911",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                      }}
                    >
                      {animatedExceptionCount}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2}>
                <Card
                  className={`h-100 todocard5 ${
                    activeCard === "All Reports" ? "active" : ""
                  }`}
                  style={{
                    backgroundColor: "#e4eff1",
                    borderRadius: "5px",
                    cursor: "pointer",
                    border: "1px solid #33919f",
                  }}
                  onClick={() => {
                    setActiveCard("All Reports");
                    setActiveListName("All Reports List");
                    setActiveSubCard("");
                    handleCardClick(TRANSCRIBER_SUMMARY_CODES.ALL_REPORTS);
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center ">
                      <Card.Title
                        style={{
                          color: "#33919f",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        All Transcriptions
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#33919f" }}
                      >
                        history_toggle_off
                      </span>
                    </div>
                    <div
                      style={{
                        color: "#33919f",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                      }}
                    >
                      {animatedAllReports}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <div
              className="my-3"
              style={{ background: "#0092D5", height: "2px" }}
            ></div>
            <div className="container-fluid px-2">
              <div className="mt-3 mb-3">
                <Row className="align-items-center justify-content-between mb-3">
                  {/* Left side: Title */}
                  <Col xs="auto" className="sectionTitle noborder pe-3">
                    {activeListName}
                  </Col>

                  {/* Right side: Controls */}
                  <Col xs="auto">
                    <div className="d-flex align-items-center gap-2">
                      {/* Date Picker */}
                      <div
                        className="date-picker-container appointment-data-range customDrodownControlDAtepicker"
                        style={{ width: "280px" }}
                      >
                        <DateRangePicker
                          label=""
                          onChange={handleDateRangeChange}
                          startDate={dateRange[0]}
                          endDate={dateRange[1]}
                          minDate={computedMinDate}
                          maxDate={computedMaxDate}
                          showResetIcon={!!dateRange[0] && !!dateRange[1]}
                          onReset={handleResetDate}
                        />
                      </div>

                      {/* Search Box */}
                      <InputGroup className="w-auto">
                        <InputGroup.Text className="px-2">
                          <span className="material-symbols-outlined text-black-50">
                            search
                          </span>
                        </InputGroup.Text>
                        <Form.Control
                          ref={inputRef}
                          aria-label="Search"
                          onChange={(e) =>
                            handleInputChange(e.target.value.trim())
                          }
                          onPaste={(e) => {
                            e.preventDefault();
                            const text = e.clipboardData.getData("text").trim();
                            handleInputChange(text);
                            if (inputRef.current) inputRef.current.value = text;
                          }}
                        />
                      </InputGroup>

                      {/* Reset Button */}
                      <Button
                        className="d-flex align-items-center"
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          padding: "10px",
                          fontSize: "22px",
                        }}
                        onClick={handleResetFilters}
                      >
                        <span className="material-icons reset_ic0">
                          restart_alt
                        </span>
                      </Button>

                      {/* Export Dropdown */}
                      <Dropdown as={ButtonGroup}>
                        <Dropdown.Toggle
                          variant="outline"
                          className="d-flex align-items-center btn-text-border appoinmentdropdown p-2"
                        >
                          <span className="material-symbols-outlined">
                            download
                          </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={handleExportExcel}>
                            Export to Excel
                          </Dropdown.Item>
                          <Dropdown.Item onClick={handleExportPDF}>
                            Export to PDF
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>

                      {/* Actions Dropdown */}
                      {selectedIds?.length > 0 && (
                        <AppointmentActionsDropdown
                          name="Actions"
                          options={finalOptions}
                          value={selectedAction}
                          onChange={handleActionChange}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="mb-2 container-fluid">
              <TransriberDataTable
                headers={TRANSCRIPITON_TODO_HEADERS}
                rows={editorData}
                isCheckbox={true}
                onSortAction={handleSortAction}
                selectedRowIds={selectedIds}
                onCheckboxSelect={handleCheckboxSelect}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
                onSaveSuccess={assignTranscriber}
                onCaseClick={handleCaseClick}
                onAction={handleDownloadSingleFileTranscriber}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center mt-0 mb-4 row p-0 m-0">
              {/* Display entries text on the left */}
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6 showingData_wrapper">
                    <span>{entriesText}</span>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex flex-row-reverse ">
                      <CustomPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={paginate}
                      />
                      <TableRowsPerPage
                        value={itemsPerPage}
                        onSelect={handleRowsPerPageChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
          <EditorCommonDrawer
            title={drawerTitle}
            open={showAppointmentActionDrawer}
            onClose={handleActionDrawer}
            placement="end"
            width={selectedAction === "Assign Transcriber" ? "40%" : "60%"}
            height={selectedAction === "Assign Transcriber" ? "400px" : "auto"}
            top={selectedAction === "Assign Transcriber" ? "auto" : "175px"}
          >
            {selectedAction === "Add Notes" && (
              <TranscriberAddNotes
                showDrawer={showAppointmentActionDrawer}
                onClose={handlecloseActionDrawer}
                caseInfoId={selectedRowData[0]?.caseInfoId}
                caseId={selectedRowData[0]?.caseId}
                isRowActionTriggered={false}
                onNotesSaved={() => {}}
                subjectQmeScheduleID={selectedRowData[0]?.subjectQmeScheduleId}
                 details = {selectedRowData[0]?.patientName + " - " + selectedRowData[0]?.caseOrExamType}

              />
            )}

            {selectedAction === "Assign Transcriber" && (
              <AssignToTranscriber
                transcriberData={selectedRowData}
                SelectedRowsDataTo={selectedIds}
                showModalNew={showAppointmentActionDrawer}
                closeModel={handlecloseActionDrawer}
                onSaveSuccess={handleSaveTranscriberChanges}
              />
            )}
          </EditorCommonDrawer>
        </div>
      )}
    </>
  );
};

export default TranscriberDashboard;
